import React, { useEffect } from "react";
import styled from "@emotion/styled";
import { Helmet } from "react-helmet-async";

import { Card, CardContent, Paper, Typography } from "@mui/material";
import MyLogoLight from "../../vendor/ME_Light.png";
import FormIscrizione from "./form-sign-up/FormIscrizione";

const Brand = styled.img`
  fill: ${(props) => props.theme.palette.primary.main};
  display: block;
  margin: 0 auto;
  width: 180px;
  margin-bottom: ${(props) => props.theme.spacing(3)};

  ${(props) => props.theme.breakpoints.up("sm")} {
    width: 220px;
  }

  ${(props) => props.theme.breakpoints.up("md")} {
    width: 256px;
    margin-bottom: ${(props) => props.theme.spacing(4)};
  }
`;

function Register() {
  return (
    <React.Fragment>
      <Card
        sx={{
          marginBottom: "16px",
          paddingTop: "8px",
          width: "100%",
          m: "32px",
        }}
      >
        <CardContent>
          <Brand src={MyLogoLight} />
          <Helmet title="Sign Up" />

          <Typography component="h1" variant="h4" align="center" gutterBottom>
            Iscrizione
          </Typography>

          <FormIscrizione />
        </CardContent>
      </Card>
    </React.Fragment>
  );
}

export default Register;
